export default __webpack_public_path__ + "static/media/fm.e5bea35e.jpg";